var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pendo-icon',{directives:[{name:"pendo-tooltip",rawName:"v-pendo-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"translation-warning-icon",attrs:{"type":"alert-circle-solid","stroke":"#fff","fill":"#DBA211","size":16}})
}
var staticRenderFns = []

export { render, staticRenderFns }